module.exports = __webpack_public_path__ + "static/media/ecofriendly-grey.1b4bc5a3.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/maker/ecofriendly-grey.svg
 ** module id = 466
 ** module chunks = 0
 **/